import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TabsTrigger"], _mergeProps({
        "data-slot": "tabs-trigger",
        class: $setup.cn(`
      items-center justify-center gap-1.5 rounded-md whitespace-nowrap px-2 py-1
      transition-[color,box-shadow,background]
      inline-flex h-[calc(100%-1px)] 
      
      text-foreground 
      text-m
      font-medium 
      
      border 
      border-transparent 
      
      data-[state=active]:bg-accent 
      data-[state=active]:text-accent-foreground
      
      hover:bg-en-blue-100
      
      disabled:pointer-events-none 
      disabled:opacity-50 
      
      focus:ring-3 
      focus:ring-ring 
      
      [&_svg]:pointer-events-none 
      [&_svg]:shrink-0 
      [&_svg:not([class*='size-'])]:size-4
      `, $setup.props.class)
    }, $setup.forwardedProps), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
